import { SLowcodeList } from 'shj-components'
import { useRef} from 'react'
import { useActivate } from 'react-activation'
import { useParams } from 'react-router-dom'

import config from './config.tsx'
import {getTradingStatementList} from "@/services/order.ts";

const PaymentList = () => {
  const { id } = useParams()
  const listRef = useRef<any>()

  useActivate(() => {
    listRef.current?.reload()
  })

  const fetchList = (values: any) => {
    const { current, pageSize, query } = values;
    return new Promise((resolve, reject) => {
      try {
        getTradingStatementList({
          params: {current, pageSize,orderId:id,transactionType:query?.transactionType||""}
        }).then(res => {
          resolve({records: res?.list||[], total:res?.count||0})
        }).catch(()=>{
          reject({success: false})
        })
      } catch {
        reject({success: false})
      }
    })
  }
  const extensions = {
    request: { fetchList },
    events: { reload: () => listRef.current?.reset() },
  }

  return <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
}

export default PaymentList
